import { KISSMETRICS_TRACK_EVENTS } from 'utils/kissmetrics'

import { EVENTS } from './events'

export const KISSMETRICS_NORMALIZED_EVENTS = {
  [EVENTS.PRICE_PAGE_VIEW]: KISSMETRICS_TRACK_EVENTS.pricing_page,
  [EVENTS.PURCHASE_CLICK]: KISSMETRICS_TRACK_EVENTS.clicked_heading,
  [EVENTS.SIGN_UP_SUCCESS]: KISSMETRICS_TRACK_EVENTS.registered,
  [EVENTS.PAYMENT_SUBMIT_CLICK]: KISSMETRICS_TRACK_EVENTS.checkout,
  [EVENTS.PROJECT_CREATION_SUCCESS]: KISSMETRICS_TRACK_EVENTS.create_project,
} as const
